<picture>
  @for (bp of breakpointsArray; track bp) {
    <source
      [media]="breakpointsMedia[bp]"
      [srcset]="image[bp].image.url"
      [class]="image[bp].imagePosition"
      />
  }

  @if (positionedImage$ | async; as positionedImage) {
    <img
      [src]="positionedImage.image.url"
      [class]="positionedImage.imagePosition"
         [alt]="positionedImage.image.alt?.length
                    ? positionedImage.image.alt
                    : ('common.image-of' | translate: { name: 'De Eekhoorn' })
                "
      [attr.loading]="lazyLoad ? 'lazy' : 'eager'"
      />
  }
</picture>
